/** Focus ring of the card system: the ring colour, set off the control. */
export const FOCUS_RING =
  'outline-none focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-3 focus-visible:outline-(--sc-ring) focus-visible:ring-0';

export const ACTION_GHOST = `h-9 rounded-[10px] px-3 text-footnote font-medium text-muted-foreground hover:bg-(--sc-subtle) hover:text-foreground ${FOCUS_RING}`;

/** A touch-sized icon button on the subtle fill, such as the header's more menu. */
export const ICON_BUTTON = `grid size-11 shrink-0 cursor-pointer place-items-center rounded-xl bg-(--sc-subtle) text-foreground hover:bg-(--sc-subtle)/70 ${FOCUS_RING}`;

export const MENU_CONTENT =
  'w-60 rounded-[14px] border-0 bg-(--sc-pop) p-1.5 shadow-(--sc-shadow-pop) motion-reduce:animate-none';

export const MENU_ITEM =
  "h-11 cursor-pointer gap-3 rounded-[10px] px-3 text-sm font-medium [&_svg:not([class*='size-'])]:size-[18px]";

/** A select or input in a panel or dialog: taller with larger text on phones, so iOS does not zoom on focus. */
// The data-size variants restate the height, since SelectTrigger pins its own on that attribute.
export const FIELD =
  'h-12 w-full rounded-xl border-0 bg-(--sc-subtle) text-base shadow-none md:h-11 md:text-sm dark:bg-(--sc-subtle) data-[size=default]:h-12 md:data-[size=default]:h-11';
